<template>
  <div class="question-box">
    <div class="content-box">
      <p class="question-box-title">回答问题，让推荐更准确</p>
      <div class="question-item" v-for="(item, index) in question.questionList" :key="index + 'question'">
        <template v-if="item.type != 'company'">
          <p>{{item.name}}{{item.value ? '' : '（未选择）'}}</p>
          <template v-if="isEdit">
            <custom-select v-model="item.value" :type="item.type" :data="item.data"/>
          </template>
          <template v-else>
            <p class="answer-text">{{item.value && item.value.toString()}}</p>
          </template>
        </template>
        <company-select v-else v-model="item.value" :is-edit="isEdit"/>
      </div>

    </div>
    <div class="planning-btn-box" v-if="resumeDetail.basic_info.cv_account === personInfo.id">
      <div :class="['planning-btn', isEdit ? 'is-edit' : '']" @click="handleClickSub">
        {{ !isEdit ? '编辑选项' : '我填好了' }}
      </div>
    </div>
  </div>
</template>
<script>
  import CustomSelect from "./custom-select"
  import CompanySelect from "./company-select"
  import question from "./question.json"
  import api from "@/api"
  import {mapState} from "vuex"
  export default {
    name: "question-box",
    props:['total'],
    data(){
      return{
        question,
        isEdit: true
      }
    },
    components:{CustomSelect, CompanySelect},
    computed:{
      ...mapState('planning', ['resumeDetail']),
      ...mapState('me', ['personInfo']),
    },
    mounted() {
      this.initDataQuestion()
      setTimeout(()=>{
        let box = document.querySelector(".question-box")
        box.style.transition = `all 0.4s linear ${this.total * 0.5 + 0.8 + 0.8}s`;
        box.className = 'question-box min'
      },1)
    },
    methods: {
      async initDataQuestion(){
        let { token } = this.$route.params
        try {
          let res = await api.planning.getPlanningIssues(token)
          if(res.code === 1000){
            let keys = Object.keys(res.data)
            keys.forEach(item=>{
              this.question.questionList[item].value = res.data[item]
              if(res.data[item] && res.data[item].toString()){
                this.isEdit = false
              }
            })
          }
        }catch (e) {
          console.log("error", e)
        }
      },
      //编辑提交
      handleClickSub(){
        if(this.isEdit){
          let params = {}
          Object.keys(this.question.questionList).forEach(key=>{
            params[key] = this.question.questionList[key].value;
            if(key === 'companies'){
              params['companies'] = this.question.questionList[key].value.map(item=>item.token)
            }
          })
          api.planning.updatePlanningIssues(this.$route.params.token, params).then(res=>{
            console.log(res)
          })
        }
        this.isEdit = !this.isEdit

      }
    }
  }
</script>

<style scoped lang="scss">
.question-box{
  width: 375px;
  height: 666px;
  background-image: url("https://files.wondercv.com/pc/planning/question-box.png");
  background-repeat: no-repeat;
  background-size: 100%;
  padding: 24px;
  box-sizing: border-box;
  position: relative;
  border-radius: 8px;
  z-index: 3;
  .content-box{
    width: 100%;
    height: 100%;
    overflow-y: auto;
    &::-webkit-scrollbar{
      display: none;
    }
    .question-box-title{
      font-size: 18px;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 25px;
      margin-bottom: 16px;
    }
    .question-item{
      margin-bottom: 16px;
      .answer-text{
        font-size: 14px;
        font-weight: 400;
        color: #FFFFFF !important;
        line-height: 20px;
      }
      &>p{
        font-size: 13px;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.6);
        line-height: 18px;
        margin-bottom: 6px;
      }
      .company-title{
        font-size: 13px;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.6);
        line-height: 18px;
        margin-bottom: 20px;
      }
      .question-input{
        width: 327px;
        height: 40px;
        ::v-deep .el-input__inner{
          background: #313744;
          border-radius: 6px;
          -webkit-appearance: none;
          border: none;
          &:hover{
            box-shadow: 0px 0px 6px 0px inset rgba(134, 161, 175, 0.4);
          }
        }
        ::v-deep input::placeholder {
          color: rgba(255, 255, 255, 0.25) !important;
        }
      }
    }
  }
  .planning-btn-box{
    position: absolute;
    bottom: 0;
    width: 375px;
    height: 106px;
    background: linear-gradient(180deg, rgba(38, 41, 51, 0) 0%, #262933 100%);
    border-radius: 8px;
    left: 0;
    box-sizing: border-box;
    padding: 38px 24px 24px;
    z-index: 3;
    .planning-btn{
      width: 327px;
      height: 44px;
      background: #313744;
      border-radius: 6px;
      text-align: center;
      line-height: 44px;
      color: #fff;
      font-size: 14px;
      font-weight: 500;
      letter-spacing: 1px;
      cursor: pointer;
      &.is-edit{
        background: linear-gradient(180deg, #FF9F79 0%, #FF6644 100%);
      }
    }
  }
  &.min{
    height: 507px;
    margin-top: 159px;
  }

}
</style>
